/**
 * Mask an API key for display, showing first 4 and last 4 characters
 * @param apiKey - The full API key to mask
 * @returns Masked string like "pk_t****_key"
 */
export function maskApiKey(apiKey: string): string {
  if (!apiKey || apiKey.length <= 8) {
    return apiKey || '';
  }
  const first = apiKey.slice(0, 4);
  const last = apiKey.slice(-4);
  return `${first}****${last}`;
}

/**
 * Copy text to clipboard
 * @param text - The text to copy
 */
export async function copyToClipboard(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}
